var _g, _text, _text2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 120,
    viewBox: "0 0 500 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10) scale(2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4C20 4 34 16 34 26.5C34 34.232 27.732 40.5 20 40.5C12.268 40.5 6 34.232 6 26.5C6 16 20 4 20 4Z",
    fill: "url(#new-water-grad)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "flame-hole"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 28,
    r: 3.5,
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#flame-hole)",
    d: "M20 12C20 12 28 19 28 26.5C28 30.9183 24.4183 34.5 20 34.5C15.5817 34.5 12 30.9183 12 26.5C12 19 20 12 20 12Z",
    fill: "url(#copper-grad)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 70,
    fontFamily: "Inter, sans-serif",
    fontSize: 60,
    fontWeight: 800,
    letterSpacing: "-3px"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#ffffff"
  }, "LH"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#ea580c"
  }, "."))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 100,
    fill: "#94a3b8",
    fontFamily: "Inter, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "3px"
  }, "\n    GAS &#38; PLUMBING\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "copper-grad",
    x1: 12,
    y1: 34.5,
    x2: 28,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea580c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdba74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "new-water-grad",
    x1: 6,
    y1: 40.5,
    x2: 34,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0284c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38bdf8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.25a416fc24b521411c6aa5e73676c18d.svg";
export { ForwardRef as ReactComponent };